import React from 'react';
import SvgIcon from 'e100-react-components/lib/components/SvgIcon';
import { IProps } from 'e100-react-components/lib/components/SvgIcon/index';

export const RoutePointForm = (props: IProps) => (
  <SvgIcon {...props}>
    <path
      d="M12 6C15.312 6 18 8.688 18 12C18 15.312 15.312 18 12 18C8.688 18 6 15.312 6 12C6 8.688 8.688 6 12 6ZM12 9C10.345 9 9 10.345 9 12C9 13.655 10.345 15 12 15C13.655 15 15 13.655 15 12C15 10.345 13.655 9 12 9Z"
      fill="#50BC46"
    />
    <circle cx="12" cy="22" r="1" fill="#515B69" />
  </SvgIcon>
);
